import { UniversalIrEngine } from './framework/UniversalIrEngine';
export class UniversalIr extends UniversalIrEngine {
}
UniversalIr.key = '-MSeHd3FH9_LOy7AM0Ed';
